import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { GQLShopFieldsContentsMessageLayout } from '../generated/graphql'

const Outer = styled.div`
  display: grid;
  grid-template-columns: 3.5fr 6.5fr;
  gap: 1.625rem;
  padding: 1.875rem;
  background-color: #F2F7FB;
  @media (max-width: 40rem){
    display: flex;
    flex-direction: column;
    margin-left: calc(var(--side-margin) * -1);
    margin-right: calc(var(--side-margin) * -1);
    padding-right: var(--page-margin);
    padding-top: 3.125rem;
    padding-bottom: 3rem;
    gap: 0;
  }
`

const Left = styled.div`
  @media (max-width: 40rem){
    margin-top: 1.3125rem;
  }
`

const Image = styled.div`
  img {
    width: 100%;
    height: auto;
  }
`

const Label = styled.div`
  font-size: 0.875rem;
  line-height: 1.5714285714285714;
  letter-spacing: 0.02em;
  margin-top: 0.1875rem;
  @media (max-width: 40rem){
    font-size: 0.75rem;
line-height: 1.4166666666666667;
letter-spacing: 0.02em;
margin-top: 0.4375rem;
  }
  &:empty {
    display: none;
  }
`

const Right = styled.div`
  @media (max-width: 40rem){
    order: -1;
  }
`

const Head = styled.div`
font-size: 1.125rem;
line-height: 1.5;
letter-spacing: 0.02em;
margin-top: calc(-0.5lh - -0.5rem);
font-weight: 700;
color: var(--blue);
@media (max-width: 40rem){
  font-size: 1.0625rem;
line-height: 0.7941176470588235;
letter-spacing: 0.02em;
text-align: center;
}
`

const Text = styled.div`
font-size: 0.9375rem;
line-height: 1.6;
margin-top: 1.1875rem;
@media (max-width: 40rem){
  font-size: 0.875rem;
line-height: 1.7857142857142858;
margin-top: 1.3125rem;
}

`

type ShopMessageProps = {
  data: DeepPartial<GQLShopFieldsContentsMessageLayout>
}
export const ShopMessage: FunctionComponent<ShopMessageProps> = ({data}) => {
  return <Outer>
    <Left>
      <Image>
        <img src={data.image?.node?.mediaItemUrl ?? ''} />
      </Image>
      <Label dangerouslySetInnerHTML={{__html: data.imageLabel ?? ''}} />
    </Left>
    <Right>
      <Head>
        現地からの声
      </Head>
      <Text dangerouslySetInnerHTML={{__html: data.text ?? ''}}/>
    </Right>
  </Outer>
}
